// 初始化的js
import "@/global/init";

// 这里是配置全局项目的内容
import Vue from 'vue'
import '@/global/directive'

// import "common/css/reset.css";
import "@/common/sass/reset.scss";

import util from "@/common/libs/util";
Object.defineProperty(Vue.prototype, '$util', { value: util })

// 引入字体图标
import '@/../static_seeker/font/iconfont.css'
import '@/../static_seeker/font/iconfont2.css'

//引入公共的elementUI组件
import 'element-ui/lib/theme-chalk/index.css'
import {
    Alert, Message, Loading, Button, Input, Icon,
    Container, Dialog, Header, Main, Footer, Aside,
    Row, Col, Form, FormItem, Popover, Image, Checkbox
} from 'element-ui';

Vue.use(Alert)
Vue.use(Button)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Icon)

Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Aside)

Vue.use(Row)
Vue.use(Col)
// 复选框--公司网申注册协议
Vue.use(Checkbox)

// Footer需要
Vue.use(Image)

// 登录需要
Vue.use(Form)
Vue.use(FormItem)

// 底部导航需要
Vue.use(Popover)

Vue.use(Dialog)

Object.defineProperty(Vue.prototype, '$message', { value: Message })

// 配置全局组件
//import FooterBox from "@/components/Footer/FooterQrcode";
import FooterBox from "@/components/Footer/SliderFooter";
import BaseLogin from "@/components/Login/Login";
import HeaderNav from "@/components/Header/HeaderNav";
import NoData from "@/components/NoData";
import SideBar from "@/components/SideBar/SideBar"

import JobfairInfo from "@/components/JobfairInfo/JobfairInfo";
import ChatQrcode from "@/components/Chat/ChatQrcode";
import InviteResume from "@/components/Invite/InviteResume";
import ApplyVideo from "@/components/video/ApplyVideo";

Vue.component('footer-box', FooterBox)
Vue.component('base-login', BaseLogin)
Vue.component('header-nav', HeaderNav)
Vue.component('no-data', NoData)
Vue.component('side-bar', SideBar)

Vue.component('jobfair-info', JobfairInfo)
Vue.component('invite-resume', InviteResume)
Vue.component('chat-qrcode', ChatQrcode)
Vue.component('apply-video', ApplyVideo)


Vue.config.productionTip = false



// WEBPACK FOOTER //
// ./src/global/index_jobfair.js